import httpClient from "../utilis/jwtRequest";

const COWORKERS_URL = "/coworkers";

function getCoworkerById(id) {
  return httpClient.get(`${COWORKERS_URL}/${id}/`);
}
function deleteCoworker(id) {
  return httpClient.delete(`${COWORKERS_URL}/${id}/`);
}
function getAllCoworkers() {
  return httpClient.get(COWORKERS_URL);
}
function getCoworkerChats(id) {
  return httpClient.get(`${COWORKERS_URL}/${id}/chats`);
}
function updateCoworker(id, newCoworker) {
  return httpClient.put(`${COWORKERS_URL}/${id}/`, newCoworker);
}
function add(newCoworker) {
  return httpClient.post(`${COWORKERS_URL}/`, newCoworker);
}
function blockCoworker(id) {
  return httpClient.post(`${COWORKERS_URL}/${id}/block`);
}
function unblockCoworker(id) {
  return httpClient.post(`${COWORKERS_URL}/${id}/unblock`);
}

export const coworkersService = {
  getCoworkerById,
  deleteCoworker,
  getAllCoworkers,
  blockCoworker,
  unblockCoworker,
  getCoworkerChats,
  updateCoworker,
  add,
};
